export function useProductDetails({
  typeHandle,
  filtroTipologiaVino,
  filtroStiliBirra,
  filtroCategoriaProdottoVino,
  filtroCategoriaLievitoVino,
  filtroCategoriaLievitoBirra,
}) {
  const { t } = useI18n()

  // Tipo di prodotto: vino o birra
  const productType = typeHandle

  // Vino adatto per / Stili birra
  const filtroList = computed(() => {
    return productType === 'vino' ? filtroTipologiaVino : filtroStiliBirra
  })

  // Prefisso per i vini, vuoto per le birre
  const itemPrefix = computed(() => {
    return productType === 'vino' ? t('product.prefix.vino') : ''
  })

  // Etichetta per i vini, 'Adatto per' per i vini, 'Stili' per le birre
  const label = computed(() => {
    return productType === 'vino' ? t('product.adattoPer') : t('product.stili')
  })

  // Categorie prodotto vino / Categorie lievito birra
  const categories = computed(() => {
    return productType === 'vino'
      ? filtroCategoriaProdottoVino
      : filtroCategoriaLievitoBirra
  })

  /* 
  Sottocategorie vino, check della category key in 'filtroCategoriaLievitoVino' 
  in base alla quale si setta il tipo di filtro (es. lieviti o tannini) per avere le sottocategorie.
  Così da poter usere usare 'slug: item.categorySlug' nei breadcrumbs prodotto
        
  params: {
    slug: item.categorySlug,
    sottocategoria: item.slug,
  },
        
  */
  const subcategories = computed(() => {
    if (productType === 'vino' && filtroCategoriaLievitoVino) {
      const lievitiCategory = categories.value.find(
        (category) => category.key === 'lieviti',
      )
      /*
      const tanniniCategory = categories.value.find(
        (category) => category.key === 'tannini',
      )
      */

      if (lievitiCategory) {
        return filtroCategoriaLievitoVino.map((subcategory) => ({
          ...subcategory,
          categorySlug: lievitiCategory.slug,
        }))
      }

      /*
      if (tanniniCategory) {
        return filtroCategoriaTanniniVino.map((subcategory) => ({
          ...subcategory,
          categorySlug: tanniniCategory.slug,
        }))
      }
      */
    }
    return []
  })

  return {
    filtroList,
    itemPrefix,
    label,
    categories,
    subcategories,
  }
}
